import * as React from "react";
import type { SVGProps } from "react";
const SvgSlippers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#slippers_svg__a)">
      <path d="M16.39 21.1a5 5 0 0 1-.92-.1 4.27 4.27 0 0 1-2.82-2.13 4.3 4.3 0 0 1-.24-3.52 17.3 17.3 0 0 0 1.12-6.09v-5a3.83 3.83 0 0 1 1.56-2.59 3.75 3.75 0 0 1 3-.59l1 .21a5 5 0 0 1 3.13 2.2 5 5 0 0 1 .67 3.77 53.4 53.4 0 0 0-2.21 9.67l-.09.74a4.3 4.3 0 0 1-4.2 3.43m-.83-16.63v4.8a19.4 19.4 0 0 1-1.25 6.78 2.27 2.27 0 0 0 .13 1.87A2.26 2.26 0 0 0 15.9 19a2.26 2.26 0 0 0 2.69-1.71l.08-.65a55.5 55.5 0 0 1 2.31-9.9 3 3 0 0 0-.42-2.17 3 3 0 0 0-1.88-1.31l-1-.22a1.7 1.7 0 0 0-1.38.28 1.68 1.68 0 0 0-.74 1.15" />
      <path d="M17.76 8.16a.8.8 0 0 1-.21 0 1 1 0 0 1-.76-1.19l.43-2a1 1 0 1 1 1.95.44l-.43 1.95a1 1 0 0 1-.98.8" />
      <path d="M14.98 11.64a1 1 0 0 1-.72-.31 1 1 0 0 1 0-1.41 14.2 14.2 0 0 0 2.54-3 1 1 0 0 1 1.95.44c-.25 1.15-2.25 3.16-3.1 4a1 1 0 0 1-.67.28" />
      <path d="M19.83 12.72a1 1 0 0 1-.84-.47c-1.15-1.79-2.46-4.16-2.2-5.3a1 1 0 0 1 1.816-.322 1 1 0 0 1 .134.752 16.7 16.7 0 0 0 1.93 3.8 1 1 0 0 1-.84 1.54M7.11 23a4.2 4.2 0 0 1-2.43-.77 4.22 4.22 0 0 1-1.7-2.74l-.07-.83A53 53 0 0 0 1.08 9a5 5 0 0 1 4-5.89l1-.17a3.7 3.7 0 0 1 2.93.71 3.74 3.74 0 0 1 1.45 2.65v.06l-.19 4.93a17.7 17.7 0 0 0 .87 6.13 4.28 4.28 0 0 1-.39 3.51 4.23 4.23 0 0 1-2.91 2q-.361.07-.73.07M6.75 4.88h-.31l-1 .17a3 3 0 0 0-2.43 3.48 54 54 0 0 1 1.82 9.92l.06.75a2.25 2.25 0 0 0 .92 1.36 2.18 2.18 0 0 0 1.68.37 2.21 2.21 0 0 0 1.54-1.06 2.25 2.25 0 0 0 .21-1.86 19.2 19.2 0 0 1-1-6.82l.17-4.8a1.73 1.73 0 0 0-.66-1.18 1.72 1.72 0 0 0-1-.33" />
      <path d="M6.15 10a1 1 0 0 1-1-.83l-.35-2a1 1 0 1 1 1.97-.35l.35 2a1 1 0 0 1-.81 1.16z" />
      <path d="M8.82 13.61a1 1 0 0 1-.72-.31c-.81-.85-2.72-3-2.93-4.11A1 1 0 0 1 5.98 8a1 1 0 0 1 1.16.81 14 14 0 0 0 2.41 3.08 1 1 0 0 1 0 1.41 1 1 0 0 1-.73.31" />
      <path d="M3.9 14.48a1 1 0 0 1-.82-1.57 14.3 14.3 0 0 0 2.08-3.79 1 1 0 0 1 1.98-.28c.2 1.16-1.2 3.47-2.42 5.21a1 1 0 0 1-.82.43" />
    </g>
    <defs>
      <clipPath id="slippers_svg__a">
        <path fill="#fff" d="M1 1h21.99v22H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSlippers;
